import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetUserOrdersDetailsResponseType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetUserOrdersDetailsInterface {
  getUserOrdersDetailsApi: UseMutateAsyncFunction<
    GetUserOrdersDetailsResponseType,
    Error,
    void,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserOrdersDetailsApi = (): UseGetUserOrdersDetailsInterface => {
  const { paymentServices } = usePaymentServices();

  const getUserOrdersDetails = () => {
    return paymentServices.getUserOrdersDetails();
  };

  const { mutateAsync, error, status } = useMutation(getUserOrdersDetails, {
    mutationKey: ['getUserOrdersDetailsApi']
  });

  return {
    getUserOrdersDetailsApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useGetUserOrdersDetailsApi };
